export default __webpack_public_path__ + "static/media/Rectangle_24.1e55e861.png";